var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nav',{staticClass:"nav"},[_c('router-link',{staticClass:"nav__link",attrs:{"to":"/register-team"}},[_vm._v("Register")]),_c('a',{staticClass:"nav__link",on:{"click":function($event){return _vm.moveTo('scoreboard__scroll-point')}}},[_vm._v(" Scoreboard ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }